import { logger } from '../utils';
import { RootService } from './rootService';
import {
    LinksDto
} from '../models';
import axiosService from './axiosService';

/**
 * Сервис для работы с заявками.
 */
export class SettingsService {
    /**
     * Корневой сервис.
     */
    root: RootService;

    /**
     * Время, на протяжении которого будут кэшироваться настройки.
     */
    readonly cacheTime: number = 15 * 60 * 1000; // 15 минут в миллисекундах

    /**
     * Конструктор.
     * @param root корневой сервис.
     */
    constructor(root: RootService) {
        this.root = root;
    }

    /**
     * Запрос на получение ссылок
     * @returns Объект ссылок
     */
    public async getLinksFromBackend(): Promise<void> {
        try {
            const cachedLinks = localStorage.getItem('links');

            if (cachedLinks) {
                const parsedLinks = JSON.parse(cachedLinks);

                // Проверяем время последнего кэширования
                const currentTime = Date.now();
                const cachedTime = new Date(parsedLinks.atCached).getTime();

                if (currentTime - cachedTime < this.cacheTime) {
                    // Используем закэшированные данные
                    return;
                }
            }

            // Если в localStorage нет данных или прошло больше 15 минут, делаем запрос
            const freshLinks = await this.fetchLinksFromBackend();
            freshLinks.atCached = new Date().toISOString();
            localStorage.setItem('links', JSON.stringify(freshLinks));
        } catch (error) {
            logger.error(error);
            return Promise.reject(error);
        }
    }

    private async fetchLinksFromBackend(): Promise<LinksDto> {
        return (await axiosService.get<LinksDto>('settings/get_links')).data;
    }

    /**
     * Геттер для получения закэшированных ссылок.
     * @returns Объект ссылок или null, если данных нет в кэше.
     */
    public get getCachedLinks(): LinksDto | undefined {
        const cachedLinks = localStorage.getItem('links');
        return cachedLinks ? (JSON.parse(cachedLinks) as LinksDto) : undefined;
    }
}
